import React from "react";


const Logo = ({ withText = true, size = 40 }) => {
  return (
    <a
      href="/"
      className="flex items-center gap-3 group"
      data-testid="brand-logo"
    >
      <div
        className="relative flex items-center justify-center"
        style={{ width: size, height: size }}
      >
        <svg
          viewBox="0 0 64 64"
          width={size}
          height={size}
          aria-label="MDST Travels logo placeholder"
        >
          <defs>
            <linearGradient id="shieldFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#FFD96A" />
              <stop offset="100%" stopColor="#F5A524" />
            </linearGradient>
          </defs>
          <path
            d="M32 4 L56 12 V30 C56 46 44 56 32 60 C20 56 8 46 8 30 V12 Z"
            fill="url(#shieldFill)"
            stroke="#0F1B2D"
            strokeWidth="2"
          />
          {/* tiny bus silhouette inside shield */}
          <rect
            x="20"
            y="24"
            width="24"
            height="16"
            rx="3"
            fill="#0F1B2D"
          />
          <rect x="23" y="27" width="6" height="5" rx="1" fill="#FFD96A" />
          <rect x="35" y="27" width="6" height="5" rx="1" fill="#FFD96A" />
          <circle cx="26" cy="42" r="2.5" fill="#0F1B2D" stroke="#fff" strokeWidth="1" />
          <circle cx="38" cy="42" r="2.5" fill="#0F1B2D" stroke="#fff" strokeWidth="1" />
        </svg>
      </div>
      {withText && (
        <div className="leading-tight">
          <div className="font-extrabold text-[1.15rem] tracking-tight">
            <span className="text-[#0F1B2D]">MDST</span>
            <span className="text-[#2563EB]">Travels</span>
          </div>
          <div className="text-[0.62rem] tracking-[0.18em] text-slate-500 font-semibold">
            SCHOOL TRANSPORT
          </div>
        </div>
      )}
    </a>
  );
};

export default Logo;
